module.exports = __webpack_public_path__ + "img/brush.e83ea6d8.svg";